export class CaseFoldedState {
    CaseId: string | null;
    IpexSusi: boolean;
    CaseReference: boolean;
    InsuranceOfficer: boolean;
    PolicyHolderInfo: boolean;
    ServiceAddress: boolean;
}
